import { Box, Button, Stack, useMediaQuery, useTheme, IconButton, Tooltip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';
import BlockIcon from '@mui/icons-material/Block';
import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import VisibilityIcon from '@mui/icons-material/Visibility';
import React from 'react';

export default function Footer({
	setModalAction,
	setModalOpen,
	setEditEnabel,
	editenabel,
	loading,
	product,
	setVendorApprove,
}: any) {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	console.log(product, 'product');
	return (
		<Box
			sx={{
				position: 'fixed',
				bottom: 0,
				left: 0,
				right: 0,
				bgcolor: 'background.paper',
				boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
				p: 1.5,
				zIndex: 10,
			}}
		>
			<Stack
				direction="row"
				spacing={1}
				justifyContent="flex-end"
				alignItems="center"
				overflow="auto"
			>
				{/* Approve */}

				{(product?.productApprovelStatus as any) !== 'APPROVED' &&
					(isMobile ? (
						<Tooltip title="Approve">
							<IconButton
								color="success"
								onClick={() => {
									setModalAction('approve');
									setModalOpen(true);
									setVendorApprove(product);
								}}
							>
								<CheckCircleIcon />
							</IconButton>
						</Tooltip>
					) : (
						<Button
							variant="contained"
							color="success"
							disabled={!editenabel}
							onClick={() => {
								setModalAction('approve');
								setModalOpen(true);
								setVendorApprove(product);
							}}
						>
							Approval
						</Button>
					))}
				{/* Enable/Disable Edit */}
				{isMobile ? (
					<Tooltip title={editenabel ? 'Enable' : 'Disable'}>
						<IconButton
							sx={{ color: editenabel ? 'primary.main' : 'black' }}
							onClick={() => setEditEnabel(!editenabel)}
						>
							{editenabel ? <EditIcon /> : <BlockIcon />}
						</IconButton>
					</Tooltip>
				) : (
					<Button
						variant="contained"
						sx={{ bgcolor: editenabel ? 'primary.main' : 'black' }}
						onClick={() => setEditEnabel(!editenabel)}
					>
						{editenabel ? 'Enable' : 'Disable'}
					</Button>
				)}
				{/* Reject */}
				{(product?.productApprovelStatus as any) !== 'REJECTED' && isMobile ? (
					<Tooltip title="Reject">
						<IconButton
							color="error"
							onClick={() => {
								setModalAction('reject');
								setModalOpen(true);
							}}
						>
							<BlockIcon />
						</IconButton>
					</Tooltip>
				) : (
					<Button
						variant="contained"
						color="error"
						onClick={() => {
							setModalAction('reject');
							setModalOpen(true);
						}}
					>
						Reject
					</Button>
				)}
				{/* Cancel */}
				{isMobile ? (
					<Tooltip title="Cancel">
						<IconButton
							color="error"
							onClick={() => window.history.back()}
							disabled={loading}
						>
							<CancelIcon />
						</IconButton>
					</Tooltip>
				) : (
					<Button
						variant="outlined"
						color="error"
						onClick={() => window.history.back()}
						disabled={loading}
					>
						Cancel
					</Button>
				)}
				{/* Save */}
				{isMobile ? (
					<Tooltip
						title={loading ? 'Loading...' : editenabel ? 'View Only' : 'Save Product'}
					>
						<IconButton color="primary" type="submit" disabled={loading || editenabel}>
							{editenabel ? <VisibilityIcon /> : <SaveIcon />}
						</IconButton>
					</Tooltip>
				) : (
					<Button
						type="submit"
						variant="contained"
						color="primary"
						disabled={loading || editenabel}
					>
						{loading ? 'Loading...' : editenabel ? 'View Only' : 'Save Product'}
					</Button>
				)}
			</Stack>
		</Box>
	);
}
